import src from "IMAGE";
export default { src, width: 101, height: 34, blurWidth: 0, blurHeight: 0};
